import styled from '@emotion/styled';

import theme from '../constants/theme';

export const AnchorLink = styled.a`
  color: ${theme.colors.linkColor};
  text-decoration: none;

  &:hover {
    color: ${theme.colors.linkHoverColor};
  }
`;
